import type { IConversationDto, IConversationResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { messages } from "@api/conversations/messages/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IConversationResponse>>,
  IPathBaseParam,
  IPaginationParams
>("conversations");
const postApis = createPostApi<
  IApiResponse<IConversationResponse>,
  IPathBaseParam,
  IConversationDto
>("conversations");
const getApis = createGetApi<
  IApiResponse<IConversationResponse>,
  IPathByIdParam,
  object
>("conversations");

export const conversations = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  messages,
};
